import { ActionTypes } from "@/App/constants/actionTypes";
import { DrugTypes } from "@/types";

type SearchForDrugAction = {
  type: typeof ActionTypes.SEARCH_FOR_DRUG;
  payload: DrugTypes.DrugSearchOptions;
  formName: string;
};

export const searchForDrug = (data: { data: DrugTypes.DrugSearchOptions; formName: string }): SearchForDrugAction => {
  return {
    type: ActionTypes.SEARCH_FOR_DRUG,
    payload: data.data,
    formName: data.formName,
  };
};

type SearchForDrugResultsAction = {
  type: typeof ActionTypes.SEARCH_FOR_DRUG_RESULTS;
  payload: DrugTypes.DrugSearchResponse;
};

export const searchForDrugResults = (data: DrugTypes.DrugSearchResponse): SearchForDrugResultsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_DRUG_RESULTS,
    payload: data,
  };
};

type SearchForSelectedDrugsAction = {
  type: typeof ActionTypes.SEARCH_FOR_SELECTED_DRUGS;
  payload: Array<DrugTypes.DrugResult>;
  formName: string;
};

export const searchForSelectedDrugs = (data: { data: Array<DrugTypes.DrugResult>, formName: string }): SearchForSelectedDrugsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_SELECTED_DRUGS,
    payload: data.data,
    formName: data.formName,
  };
};

type SearchForSelectedDrugsResultsAction = {
  type: typeof ActionTypes.SEARCH_FOR_SELECTED_DRUGS_RESULTS;
  payload: Array<DrugTypes.DrugResult>;
};

export const searchForSelectedDrugsResults = (data: Array<DrugTypes.DrugResult>): SearchForSelectedDrugsResultsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_SELECTED_DRUGS_RESULTS,
    payload: data,
  };
};

export type DrugSearchActions = SearchForDrugAction | SearchForDrugResultsAction | SearchForSelectedDrugsAction | SearchForSelectedDrugsResultsAction;
